import { gsap, ScrollTrigger } from '@gsap';

/**
 * Layout: Content - Afbeelding Grid
 * Slug: content_afbeelding_grid
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.content_afbeelding_grid-layout');

	layouts.forEach((layout) => {
		const contentElements = layout.querySelectorAll(".text-col > *");
		gsap.from(contentElements, {
			opacity: 0,
			stagger: 0.2,
			scrollTrigger: {
				trigger: layout,
				markers: false,
				start: "top center-=20%",
				end: "bottom center"
			}
		});

		gsap.from(layout.querySelectorAll(".image-grid-container img"), {
			scale: 0.5,
			stagger: 0.1,
			scrollTrigger: {
				trigger: layout.querySelector(".image-grid-container"),
				scrub: 2,
				start: "top bottom",
				end: "bottom-=25% bottom",
				markers: false
			}
		});
	});
});
